import React from 'react';
import { checkNested } from 'MODULES/checkNested';
import getMotDateValue from 'MODULES/getMotDateValue';
import { CATEGORIES } from 'MODULES/CATEGORIES';
import { FILTER_DISPLAY_TYPE, filterId } from 'CONST';

const CategoryFilters = ({ filters, category, i18n }) => filters.map(f => {
    const filterData = f.filter?.filter || {};
    const cssClass = checkNested(filterData, 'cssClass', '');
    const filter = filterData.id;

    const isMotorcycle = [
        CATEGORIES.moto,
        CATEGORIES.motorcycle,
        CATEGORIES.motorScooters,
        CATEGORIES.buggies,
        CATEGORIES.cartings,
        CATEGORIES.snowMobiles,
        CATEGORIES.atv,
        CATEGORIES.tricycles,
        CATEGORIES.motorcycleRental
    ].includes(category);

    const model = filter === filterId.model;
    const transmission = filter === filterId.transmission;
    const fuelType = filter === filterId.fuel;
    const calendar = filter === filterId.calendar;
    const distance = filter === filterId.distance;

    if (
        !cssClass
        || (!isMotorcycle && (model))
        || (isMotorcycle && (transmission || fuelType))
    ) return null;

    const formatNumberWithThinSpace = (value) => {
        if ((typeof value === 'number' || /^\d+$/.test(value)) && value.toString().length > 4) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        return value;
    };

    const altValues = f.filter.alternativeValues;
    const rounded = value => Math.round(value * 10) / 10;

    let displayValue;

    if (altValues) {
        if (!isMotorcycle) {
            const value = rounded(altValues[0].value);
            const suffix = value % 1 === 0 ? '.0' : '';
            displayValue = `${value}${suffix}${altValues[0].name}`;
        } else {
            displayValue = `${altValues[1].value}${altValues[1].name}`;
        }
    } else {
        displayValue = filterData.displayType === FILTER_DISPLAY_TYPE.mot
            ? getMotDateValue(f.val)
            : formatNumberWithThinSpace(f.val);
    }

    return (
        <div key={f.id} title={checkNested(f.filter, 'filter.name', '')}>
            <i className={`pp-landing ${cssClass}`} />
            {displayValue}
            {calendar && i18n.p__('Short', 'y')}
            {distance && i18n.p__('Short', 'km')}
        </div>
    );
});

export default CategoryFilters;
